export enum LookupRelationType {
    None = 0,
    OneToOne = 1,
    OneToMany = 2,
    ManyToMany = 3
}
